export default "__VITE_ASSET__BlJ827km__"